// APIに指定するFrameのあぶり出し関数(サブスク)
export const setMultipleFrame = (sheet) => {
  console.log("使用済み・未使用のフレームArrayを弾き出してストアへ");
  console.log("setMultipleFrame :>> start");

  // 使用済みのフレーム
  let used_frames = sheet.frames.filter(function (value) {
    return value.stamped_at;
  });
  // 未使用のフレーム
  let unused_frames = sheet.frames.filter(function (value) {
    return !value.stamped_at;
  });

  console.log("used_frames :>> ", used_frames, unused_frames);
  console.log("unused_frames :>> ", unused_frames);
  console.log("setMultipleFrame :>> end");
  return [used_frames, unused_frames];
};
